import { PatientStateEnum } from "requests";

export const STATE_OPTIONS = [
  {
    label: "Normal",
    value: PatientStateEnum.Normal
  },
  { label: "Abnormal", value: PatientStateEnum.Abnormal }
];
